import React, { Component } from 'react'
import { toggleIsLoading } from 'Redux/actions/ViewStateActions'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  AttachmentsContainer,
  ButtonAdd,
  File,
  HeadContainer,
  InputCol,
  LevelRowContainer,
  MainWrapper,
  RoundedWrapper,
} from './styles'
import { withRouter } from 'react-router'
import { withTheme } from 'styled-components'
import { Label } from 'components/atoms/Texts/TxtLabel'
import lo from 'lodash'
import { TxtLink } from 'components/atoms/Texts/TxtLink'
import { COAL_STOCK_ATTACHMENT } from 'fixtures/api'
import Icon from 'atoms/Icon'
import ic_add from 'App/assets/images/ic_add.png'
import ic_pdf from 'App/assets/images/ic-file-pdf.png'
import ic_image from 'App/assets/images/ic-file-image.png'
import IconPng from 'components/atoms/IconPng/index'
import { deleteDataDifReturn } from 'services/cmsService'

const FILE_TYPES = {
  png: ic_image,
  jpg: ic_image,
  pdf: ic_pdf,
}

const MAX_FILE_SIZES = 10 * 1024 * 1024

export class StockOpnameAttachmentsForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      coalStockInventoryAttachments: [],
    }
  }

  componentDidUpdate(prevProps) {
    if (
      !lo.isEqual(
        this.props.form.length,
        prevProps.form.length
      ) &&
      !this.state.coalStockInventoryAttachments.length
    ) {
      this.init()
    } else if (!lo.isEqual(this.props.form, prevProps.form)) {
      this.setState({
        coalStockInventoryAttachments: [
          ...this.state.coalStockInventoryAttachments,
          ...this.props.form
        ]
      })
    }
  }

  init() {
    // init state
    this.setState({
      coalStockInventoryAttachments:
        this.props.form,
    })
  }
  async fnChange(val) {
    const { onChange } = this.props
  
    const readFile = (file) => {
      return new Promise((resolve, reject) => {
        if (file.size > MAX_FILE_SIZES) {
          alert(`The file "${file.name}" exceeds the maximum size of 10MB.`)
          return resolve(null) 
        }
  
        const reader = new FileReader()
        reader.onload = (event) => {
          resolve({
            filename: file.name,
            mimeType: file.type,
            media: {
              type: ['png', 'jpg', 'jpeg'].includes(this.getExtension(file.name))
                ? 'IMAGE'
                : 'DOCUMENT',
            },
            file: event.target.result.split(',')[1],
          })
        }
        reader.onerror = reject
        reader.readAsDataURL(file)
      })
    }
  
    const filePromises = Array.from(val).map(readFile)
    const results = await Promise.all(filePromises)
  
    const validFiles = results.filter(Boolean)
    onChange(validFiles)
  }  

  async fnRemoveEvidence(file, index) {
    const { form, onChangeForm } = this.props

    const found = this.state.coalStockInventoryAttachments.findIndex(
      (d, i) => index === i
    )
    if (found === -1) {
      return
    }

    const confirmDelete = window.confirm(
      `Are you sure, you want to delete file ${this.state.coalStockInventoryAttachments[index].filename} ?`
    )
    if (!confirmDelete) return

    try {
      toggleIsLoading(true)
      
      const res = await deleteDataDifReturn(`${COAL_STOCK_ATTACHMENT}/${this.state.coalStockInventoryAttachments[found].id}`)
      if (res.status < 400) {
        const newData = this.state.coalStockInventoryAttachments.filter(
          (d, i) => index !== i
        )
        this.setState({ coalStockInventoryAttachments: newData }, () => {
          form['coalStockInventoryAttachments'] = newData
          onChangeForm(form)
        })
      } else {
        const message = res.message ? res.message : "Failed to upload"
        alert(message)
        throw res
      }
    } catch (error) {
      alert(error)
    } finally {
      toggleIsLoading(false)
    }
  }

  getExtension(filename) {
    let arr = filename.split('.')
    let extension = arr.pop()
    return extension
  }

  handleDownload(e) {
    if (e.fileId) {
      window.open(e.file.downloadUrl, '_self')
      return
    }
    const link = document.createElement("a");
    link.href = `data:application/pdf;base64,${e.file}`;
    link.download = e.fileId ? e.file.name : e.filename;
    link.click();
  }

  render() {
    const { theme, enableField } = this.props
    return (
      <RoundedWrapper>
        <MainWrapper>
          <HeadContainer>
            <Label
              lineheight={'29px'}
              size={'16px'}
              mb={'0px'}
            >
              Upload Document
            </Label>
          </HeadContainer>
          <LevelRowContainer>
            <InputCol>
              <Label
                lineheight={'14px'}
                size={'12px'}
              >
                Attachments
              </Label>
              <div>
                <div>
                  {
                   enableField && (
                    <ButtonAdd
                      src={ic_add}
                      onClick={() => document.getElementById('evidence').click()}
                    />
                   )
                  }
                </div>
                <input
                  id="evidence"
                  type="file"
                  accept={Object.keys(FILE_TYPES).join(',')}
                  onChange={(e) => this.fnChange(e.target.files)}
                  multiple
                  hidden
                />
                <AttachmentsContainer>
                  {this.state.coalStockInventoryAttachments.map((e, i) =>
                    !e.id ? (
                      <File key={i}>
                        <IconPng
                          srcIcon={
                            FILE_TYPES[
                              this.getExtension(
                                e.fileId ? e.file.name : e.filename
                              )
                            ]
                          }
                          size={'auto'}
                          h={'24'}
                          mr={'20px'}
                        />
                        <Label
                          lineheight={'14px'}
                          size={'12px'}
                          mb="0"
                        >
                          {e.fileId ? e.file.name : e.filename}
                        </Label>
                        {
                          enableField && (
                            <Icon
                              ml="auto"
                              name="times-circle"
                              color={theme.mocaRed}
                              onClick={() => this.fnRemoveEvidence(e, i)}
                              showPointer
                            />
                          )
                        }
                      </File>
                    ) : (
                      <File key={i}>
                        <TxtLink
                          size={'12px'}
                          lineheight={'14px'}
                          weight={'400'}
                          color={theme.mocaGrey}
                          title={e.fileId ? e.file.name : e.filename}
                          isNewTab
                          onClick={() => this.handleDownload(e)}
                        >
                          <IconPng
                            srcIcon={
                              FILE_TYPES[
                                this.getExtension(
                                  e.fileId ? e.file.name : e.filename
                                )
                              ]
                            }
                            size={'auto'}
                            h={'24'}
                            mr={'20px'}
                          />
                          <Label
                            lineheight={'14px'}
                            size={'12px'}
                            mb="0"
                          >
                            {e.fileId ? e.file.name : e.filename}
                          </Label>
                        </TxtLink>
                        {
                          enableField && <Icon
                            ml="auto"
                            name="times-circle"
                            color={theme.mocaRed}
                            onClick={() => this.fnRemoveEvidence(e, i)}
                            showPointer
                          />
                        }
                      </File>
                    )
                  )}
                </AttachmentsContainer>
              </div>
            </InputCol>
          </LevelRowContainer>
        </MainWrapper>
      </RoundedWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    viewState: state.viewState,
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      toggleIsLoading,
    },
    dispatch
  )

export default withRouter(
  withTheme(
    connect(mapStateToProps, mapDispatchToProps)(StockOpnameAttachmentsForm)
  )
)
